import { useState } from "react";
import { FileSpreadsheet, FileDown } from "lucide-react";
import { toast } from "sonner";
import { useApi, downloadFile, errMsg } from "../lib/api";
import { PageHead, Card, Field, Input, Btn, Loading, Empty, Overline } from "../components/kit";
import { todayWIB } from "../lib/constants";

const KINDS = [
  ["orders", "Order per Periode"],
  ["production", "Produksi per Operator"],
  ["reject", "Tingkat Reject"],
  ["stock", "Mutasi Stok"],
];

export default function Reports() {
  const today = todayWIB();
  const [kind, setKind] = useState("orders");
  const [range, setRange] = useState({ start: today.slice(0, 8) + "01", end: today });
  const [busy, setBusy] = useState("");
  const qs = `start=${range.start}&end=${range.end}`;
  const { data } = useApi(`/reports/${kind}?${qs}`, 0);
  const exp = async (fmt) => {
    setBusy(fmt);
    try { await downloadFile(`/reports/${kind}?${qs}&format=${fmt}`, `laporan_${kind}_${range.start}_${range.end}.${fmt}`); }
    catch (x) { toast.error(errMsg(x)); } finally { setBusy(""); }
  };
  return (
    <>
      <PageHead title="Laporan" sub="Ekspor ke Excel atau PDF" />
      <div className="flex gap-2 overflow-x-auto pb-1" data-testid="report-kinds">
        {KINDS.map(([k, l]) => (
          <button key={k} onClick={() => setKind(k)} data-testid={`report-kind-${k}`}
            className={`shrink-0 h-11 px-4 rounded-full font-bold text-sm border ${kind === k ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-600 border-slate-300"}`}>{l}</button>
        ))}
      </div>
      <Card className="grid grid-cols-2 md:grid-cols-4 gap-3 items-end">
        <Field label="Dari"><Input type="date" value={range.start} onChange={(e) => setRange({ ...range, start: e.target.value })} data-testid="report-start-input" /></Field>
        <Field label="Sampai"><Input type="date" value={range.end} onChange={(e) => setRange({ ...range, end: e.target.value })} data-testid="report-end-input" /></Field>
        <Btn variant="success" loading={busy === "xlsx"} onClick={() => exp("xlsx")} data-testid="export-excel-btn"><FileSpreadsheet className="w-5 h-5" /> Excel</Btn>
        <Btn variant="danger" loading={busy === "pdf"} onClick={() => exp("pdf")} data-testid="export-pdf-btn"><FileDown className="w-5 h-5" /> PDF</Btn>
      </Card>
      {!data ? <Loading /> : (
        <>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-3" data-testid="report-summary">
            {Object.entries(data.summary).map(([k, v]) => (
              <Card key={k} className="!p-4"><Overline>{k}</Overline><div className="mt-1 font-mono font-extrabold text-lg">{v}</div></Card>
            ))}
          </div>
          {data.rows.length === 0 ? <Empty text="Tidak ada data pada periode ini." data-testid="report-empty" /> : (
            <div className="overflow-x-auto bg-white rounded-2xl border border-slate-200" data-testid="report-table">
              <table className="w-full text-sm">
                <thead className="bg-slate-900 text-white"><tr>{data.columns.map((c) => <th key={c} className="px-3 py-3 text-left font-bold whitespace-nowrap">{c}</th>)}</tr></thead>
                <tbody>{data.rows.map((r, i) => <tr key={r.join("|") + i} className="border-t border-slate-100 even:bg-slate-50">{r.map((v, j) => <td key={data.columns[j]} className="px-3 py-2.5 whitespace-nowrap">{v}</td>)}</tr>)}</tbody>
              </table>
            </div>
          )}
        </>
      )}
    </>
  );
}
